// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/LufgaMedium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/LufgaExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/bgauth.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.-left-\\[240px\\] {
  left: -240px;
}
.-right-\\[400px\\] {
  right: -400px;
}
.-top-20 {
  top: -5rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.left-0 {
  left: 0px;
}
.left-\\[230px\\] {
  left: 230px;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-4 {
  top: 1rem;
}
.top-9 {
  top: 2.25rem;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[51\\] {
  z-index: 51;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.\\!mb-4 {
  margin-bottom: 1rem !important;
}
.\\!mt-0 {
  margin-top: 0px !important;
}
.\\!mt-2 {
  margin-top: 0.5rem !important;
}
.\\!mt-3 {
  margin-top: 0.75rem !important;
}
.\\!mt-8 {
  margin-top: 2rem !important;
}
.-ml-6 {
  margin-left: -1.5rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-20 {
  margin-left: 5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-14 {
  margin-right: 3.5rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.\\!h-6 {
  height: 1.5rem !important;
}
.\\!h-9 {
  height: 2.25rem !important;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[176px\\] {
  height: 176px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[418px\\] {
  height: 418px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[88px\\] {
  height: 88px;
}
.h-\\[calc\\(100\\%-32px\\)\\] {
  height: calc(100% - 32px);
}
.h-\\[calc\\(100\\%-50px\\)\\] {
  height: calc(100% - 50px);
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-20 {
  min-height: 5rem;
}
.min-h-\\[340px\\] {
  min-height: 340px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[420px\\] {
  min-height: 420px;
}
.min-h-\\[46px\\] {
  min-height: 46px;
}
.min-h-fit {
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.\\!w-1\\/2 {
  width: 50% !important;
}
.\\!w-80 {
  width: 20rem !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[123px\\] {
  width: 123px;
}
.w-\\[209px\\] {
  width: 209px;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[4px\\] {
  width: 4px;
}
.w-\\[5\\%\\] {
  width: 5%;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.\\!min-w-52 {
  min-width: 13rem !important;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-44 {
  min-width: 11rem;
}
.min-w-48 {
  min-width: 12rem;
}
.max-w-20 {
  max-width: 5rem;
}
.max-w-32 {
  max-width: 8rem;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.text-balance {
  text-wrap: balance;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-br-md {
  border-bottom-right-radius: 0.375rem;
}
.rounded-tl-\\[40px\\] {
  border-top-left-radius: 40px;
}
.rounded-tr-\\[40px\\] {
  border-top-right-radius: 40px;
}
.rounded-tr-md {
  border-top-right-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-\\[\\#9E9FAA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(158 159 170 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.\\!bg-\\[\\#FF3E3E\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 62 62 / var(--tw-bg-opacity)) !important;
}
.\\!bg-gray-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#00E9D0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 233 208 / var(--tw-bg-opacity));
}
.bg-\\[\\#2083FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(32 131 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#3385ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 133 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#9799A3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(151 153 163 / var(--tw-bg-opacity));
}
.bg-\\[\\#9B9DAC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(155 157 172 / var(--tw-bg-opacity));
}
.bg-\\[\\#B4D0F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(180 208 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#BD6D40\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(189 109 64 / var(--tw-bg-opacity));
}
.bg-\\[\\#BF9500\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(191 149 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#EAEAEA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 234 234 / var(--tw-bg-opacity));
}
.bg-\\[\\#FF3E3E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 62 62 / var(--tw-bg-opacity));
}
.bg-\\[\\#eaeaea\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 234 234 / var(--tw-bg-opacity));
}
.bg-\\[\\#ef6a6a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 106 106 / var(--tw-bg-opacity));
}
.bg-\\[\\#f4f8ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 248 255 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-opacity-55 {
  --tw-bg-opacity: 0.55;
}
.bg-opacity-65 {
  --tw-bg-opacity: 0.65;
}
.\\!p-8 {
  padding: 2rem !important;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.\\!pb-4 {
  padding-bottom: 1rem !important;
}
.\\!pl-4 {
  padding-left: 1rem !important;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.\\!text-left {
  text-align: left !important;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.\\!text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-normal {
  font-weight: 400 !important;
}
.font-bold {
  font-weight: 700;
}
.font-extralight {
  font-weight: 200;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.\\!normal-case {
  text-transform: none !important;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#111111\\] {
  --tw-text-opacity: 1;
  color: rgb(17 17 17 / var(--tw-text-opacity));
}
.text-\\[\\#2083FF\\] {
  --tw-text-opacity: 1;
  color: rgb(32 131 255 / var(--tw-text-opacity));
}
.text-\\[\\#294aa5\\] {
  --tw-text-opacity: 1;
  color: rgb(41 74 165 / var(--tw-text-opacity));
}
.text-\\[\\#2BD483\\] {
  --tw-text-opacity: 1;
  color: rgb(43 212 131 / var(--tw-text-opacity));
}
.text-\\[\\#50516C\\] {
  --tw-text-opacity: 1;
  color: rgb(80 81 108 / var(--tw-text-opacity));
}
.text-\\[\\#9B9DAC\\] {
  --tw-text-opacity: 1;
  color: rgb(155 157 172 / var(--tw-text-opacity));
}
.text-\\[\\#9E9FAA\\] {
  --tw-text-opacity: 1;
  color: rgb(158 159 170 / var(--tw-text-opacity));
}
.text-\\[\\#9EA0AA\\] {
  --tw-text-opacity: 1;
  color: rgb(158 160 170 / var(--tw-text-opacity));
}
.text-\\[\\#D9D9D9\\] {
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity));
}
.text-\\[\\#FF3E3E\\] {
  --tw-text-opacity: 1;
  color: rgb(255 62 62 / var(--tw-text-opacity));
}
.text-\\[\\#ef6a6a\\] {
  --tw-text-opacity: 1;
  color: rgb(239 106 106 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-60 {
  opacity: 0.6;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
@font-face {
  font-family: lufga;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: lufga;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 200;
  font-style: normal;
  font-display: block;
}
body {
  font-family: lufga;
  background-color: #edeff4;
  overflow-x: hidden;
}

#webpack-dev-server-client-overlay {
  display: none;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: white;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(111, 133, 147, 0.1);
}

.title-card {
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 4px;
}

.auth-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.card {
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border-radius: 20px;
  padding: 32px 24px 24px 24px;
  border: 1px solid #e6e6e6;
}

.MuiTooltip-popper .MuiTooltip-tooltip {
  background-color: #eaeaea !important;
}

.MuiTooltip-arrow {
  color: #eaeaea !important;
}

.sub-menu {
  position: absolute;
  top: 4rem;
  z-index: 10;
  min-height: 8rem;
  width: 335px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  border-bottom-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

table {
  width: 100%;
}
table tbody tr td {
  font-size: 14px;
}
table tbody tr td * {
  font-size: 14px;
}
table thead tr {
  border-radius: 6px;
  overflow: hidden;
}
table thead tr th {
  background-color: #f0f4f9;
  font-weight: 400;
  color: #374557;
}
table thead tr th :first-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
table thead tr th :last-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.auth-wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.box-auth {
  width: 100%;
  border-radius: 1rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  width: 408px;
  background-color: #ffffff;
  min-height: 529px;
}

.box-auth2 {
  width: 100%;
  border-radius: 1rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  width: 408px;
  background-color: #ffffff;
  height: 507px;
}

.link-auth {
  font-size: 1rem;
  line-height: 1.5rem;
  color: #3385ff;
}

.input-container {
  position: relative;
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.input-container label {
  margin-bottom: 0.25rem;
  text-align: left;
  font-weight: 300;
  text-transform: uppercase;
  color: #000;
  font-size: 15px;
}
.input-container input {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-left: 2.75rem;
  padding-right: 0.5rem;
}
.input-container input:focus::placeholder {
  --tw-placeholder-opacity: 0.7;
}
.input-container input:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.input-container input {
  height: 40px;
  background-color: #ffffff;
  border-color: #d9d9d9;
  font-size: 17px;
  color: #222;
}
.input-container input::placeholder {
  color: #aaa;
}
.input-container input.custom {
  padding-left: 1rem;
  background-color: #f3f4f6 !important;
  border-color: #f3f4f6 !important;
}
.input-container input.custom.error {
  border-color: #ef6a6a;
}
.input-container input.error {
  border-color: #ef6a6a;
}
.input-container input::placeholder {
  font-size: 15px;
  color: #9b9dac;
}
.input-container .icon {
  position: absolute;
  top: 0.75rem;
  left: 1.25rem;
  color: #95989a;
}
.input-container .icon-2 {
  position: absolute;
  right: 1.25rem;
  top: 0.75rem;
  cursor: pointer;
  color: #95989a;
}

.link-auth-login {
  color: #000000;
  transition: all 0.2s ease;
}
.link-auth-login:hover {
  color: #352d3b;
}

.link-auth-register {
  background-color: #000000;
  color: white;
  border-radius: 4px;
  width: 123px;
  height: 40px;
  display: flex;
  transition: all 0.2s ease;
  justify-content: center;
  align-items: center;
}
.link-auth-register:hover {
  background-color: #352d3b;
}

.submit-btn {
  margin-top: 4rem;
  margin-bottom: 1rem;
  display: flex;
  height: 2.5rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  background-color: #000000;
  transition: all 0.2s ease;
}
.submit-btn.no-top-margin {
  margin-top: 0;
}
.submit-btn:hover {
  background-color: #352d3b;
}
.submit-btn:disabled {
  background-color: #d0d0d0;
}

.verification-code-styles {
  width: 100%;
  --ReactInputVerificationCode-itemWidth: 60px;
  --ReactInputVerificationCode-itemHeight: 50px;
}
.verification-code-styles .ReactInputVerificationCode__container {
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.75rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  max-width: 400px;
}
.verification-code-styles .ReactInputVerificationCode__item:focus {
  outline: none;
}
.verification-code-styles .ReactInputVerificationCode__container div {
  box-shadow: unset !important;
}
.verification-code-styles .ReactInputVerificationCode__item {
  border-radius: 13px;
  font-size: 16px !important;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  line-height: 50px !important;
  color: #000;
}
.verification-code-styles .ReactInputVerificationCode__item.is-active {
  border: 1px solid #000000;
}
.verification-code-styles.has-error .ReactInputVerificationCode__item {
  border: 1px solid #ef6a6a;
}

.datetimepicker .MuiInputBase-root {
  height: 40px;
  background-color: #fff;
  border-radius: 8px;
  padding-right: 12px !important;
  max-width: 180px;
}
.datetimepicker .MuiInputBase-root:hover {
  border: none !important;
}
.datetimepicker .MuiInputBase-root * {
  color: #eaeaea;
}
.datetimepicker .MuiInputBase-root input {
  font-size: 13px;
  padding-left: 5px !important;
  color: #000 !important;
}
.datetimepicker .MuiInputBase-root input::placeholder {
  opacity: 0 !important;
}
.datetimepicker .MuiInputBase-root input:hover {
  border: none !important;
}
.datetimepicker .MuiInputBase-root input:focus::placeholder {
  opacity: 0;
}
.datetimepicker .MuiInputBase-root .MuiSvgIcon-root {
  fill: #000;
  opacity: 0.38;
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.focus\\:border-gray-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-\\[\\#D0D0D0\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(208 208 208 / var(--tw-bg-opacity));
}
@media (min-width: 768px) {

  .md\\:top-3 {
    top: 0.75rem;
  }

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:\\!w-1\\/2 {
    width: 50% !important;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:left-0 {
    left: 0px;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:gap-3 {
    gap: 0.75rem;
  }

  .lg\\:pl-\\[252px\\] {
    padding-left: 252px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/main.scss"],"names":[],"mappings":"AAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;AAEA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAEA;EACE,kBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAGA;EACE,kBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AADF;AAIA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AAFF;;AAKA;EACE,0CAAA;AAFF;;AAKA;EACE,gCAAA;EACA,mBAAA;AAFF;;AAKA;EACE,yDAAA;AAFF;;AAKA;EACE,sBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,yBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAME;EAAA,kBAAA;EAAA,SAAA;EAAA,WAAA;EAAA,gBAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,uGAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA,0BAAA;EACA,gCAAA;EACA,4BAAA;EACA;AAHA;;AAMF;;EAEE,wBAAA;EACA,SAAA;AAFF;;AAKA,YAAA;AACA;EACE,0BAAA;AAFF;;AAKA;EACE,WAAA;AAFF;AAKM;EACE,eAAA;AAHR;AAIQ;EACE,eAAA;AAFV;AAQI;EACE,kBAAA;EACA,gBAAA;AANN;AAOM;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AALR;AAMQ;EACE,4BAAA;EACA,+BAAA;AAJV;AAMQ;EACE,2BAAA;EACA,8BAAA;AAJV;;AAYE;EAAA,aAAA;EAAA,iBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA;AAAA;;AAIA;EAAA,WAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;EACA,YAAA;EACA,yBAAA;EACA;AAHA;;AAOA;EAAA,WAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;EACA,YAAA;EACA,yBAAA;EACA;AAHA;;AAOA;EAAA,eAAA;EAAA,mBAAA;EACA;AADA;;AAKA;EAAA,kBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,aAAA;EAAA,sBAAA;EAAA;AAAA;AAGE;EAAA,sBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,yBAAA;EACA,WAAA;EACA;AAFA;AAMA;EAAA,WAAA;EAAA,uBAAA;EAAA,iBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AADF;EAEE,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AATJ;AAUI;EACE,WAAA;AARN;AAWM;EAAA,kBAAA;EACA,oCAAA;EACA;AAFA;AAGA;EACE,qBAAA;AAPR;AAUI;EACE,qBAAA;AARN;AAUI;EACE,eAAA;EACA,cAAA;AARN;AAYI;EAAA,kBAAA;EAAA,YAAA;EAAA,aAAA;EACA;AADA;AAIA;EAAA,kBAAA;EAAA,cAAA;EAAA,YAAA;EAAA,eAAA;EACA;AADA;;AAKJ;EACE,cAAA;EACA,yBAAA;AAVF;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAVF;AAWE;EACE,yBAAA;AATJ;;AAcE;EAAA,gBAAA;EAAA,mBAAA;EAAA,aAAA;EAAA,cAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gDAAA;EACA,yBAAA;EACA;AAFA;AAGA;EACE,aAAA;AATJ;AAWE;EACE,yBAAA;AATJ;AAWE;EACE,yBAAA;AATJ;;AAcE;EAAA,WAAA;EACA,4CAAA;EACA;AAFA;AAKE;EAAA,iBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,aAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,8BAAA;EAAA,YAAA;EACA;AADA;AAIF;EACE,aAAA;AAXJ;AAcE;EACE,4BAAA;AAZJ;AAeE;EACE,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;AAbJ;AAcI;EACE,yBAAA;AAZN;AAiBI;EACE,yBAAA;AAfN;;AAsBE;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AAnBJ;AAoBI;EACE,uBAAA;AAlBN;AAoBI;EACE,cAAA;AAlBN;AAoBI;EACE,eAAA;EACA,4BAAA;EACA,sBAAA;AAlBN;AAmBM;EACE,qBAAA;AAjBR;AAmBM;EACE,uBAAA;AAjBR;AAoBQ;EACE,UAAA;AAlBV;AAsBI;EACE,UAAA;EACA,aAAA;AApBN;AAhRA;EAAA;AAgRA;AAhRA;EAAA,sBAgRA;EAhRA;AAgRA;AAhRA;EAAA,8BAgRA;EAhRA;AAgRA;AAhRA;EAAA;AAgRA;AAhRA;EAAA,kBAgRA;EAhRA;AAgRA;AAhRA;;EAAA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;AAAA;AAhRA;;EAAA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;;EAhRA;IAAA;EAgRA;AAAA","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n@font-face {\r\n  font-family: lufga;\r\n  src: url(\"../fonts/LufgaMedium.ttf\") format(\"truetype\");\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: block;\r\n}\r\n\r\n@font-face {\r\n  font-family: lufga;\r\n  src: url(\"../fonts/LufgaExtraLight.ttf\") format(\"truetype\");\r\n  font-weight: 200;\r\n  font-style: normal;\r\n  font-display: block;\r\n}\r\n\r\nbody {\r\n  font-family: lufga;\r\n  background-color: #edeff4;\r\n  overflow-x: hidden;\r\n}\r\n\r\n#webpack-dev-server-client-overlay {\r\n  display: none;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: white;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: rgba(111, 133, 147, 0.1);\r\n}\r\n\r\n.title-card {\r\n  border-bottom: 1px solid #e6e6e6;\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.auth-bg {\r\n  background-image: url(../assets/bgauth.svg);\r\n}\r\n\r\n.card {\r\n  background-color: #fff;\r\n  transition: all 0.5s ease-in-out;\r\n  position: relative;\r\n  border-radius: 20px;\r\n  padding: 32px 24px 24px 24px;\r\n  border: 1px solid #e6e6e6;\r\n}\r\n\r\n.MuiTooltip-popper .MuiTooltip-tooltip {\r\n  background-color: #eaeaea !important;\r\n}\r\n\r\n.MuiTooltip-arrow  {\r\n  color: #eaeaea !important;\r\n}\r\n\r\n.sub-menu {\r\n  @apply min-h-32 z-10 shadow-sm bg-white absolute w-[335px] transition-all top-16;\r\n  border-bottom-right-radius: 20px;\r\n  border-top-left-radius: 20px;\r\n  border-bottom-left-radius: 20px;\r\n}\r\n\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=\"number\"] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  tbody {\r\n    tr {\r\n      td {\r\n        font-size: 14px;\r\n        * {\r\n          font-size: 14px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  thead {\r\n    tr {\r\n      border-radius: 6px;\r\n      overflow: hidden;\r\n      th {\r\n        background-color: #f0f4f9;\r\n        font-weight: 400;\r\n        color: #374557;\r\n        :first-child {\r\n          border-top-right-radius: 6px;\r\n          border-bottom-right-radius: 6px;\r\n        }\r\n        :last-child {\r\n          border-top-left-radius: 6px;\r\n          border-bottom-left-radius: 6px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.auth-wrapper {\r\n  @apply justify-center items-center p-2 flex min-h-screen flex-col;\r\n}\r\n\r\n.box-auth {\r\n  @apply w-full rounded-2xl shadow-md px-10 py-16;\r\n  width: 408px;\r\n  background-color: #ffffff;\r\n  min-height: 529px;\r\n}\r\n\r\n.box-auth2 {\r\n  @apply w-full rounded-2xl shadow-md px-10 py-16;\r\n  width: 408px;\r\n  background-color: #ffffff;\r\n  height: 507px;\r\n}\r\n\r\n.link-auth {\r\n  @apply text-base;\r\n  color: #3385ff;\r\n}\r\n\r\n.input-container {\r\n  @apply my-8 flex flex-col justify-center relative;\r\n\r\n  label {\r\n    @apply text-left uppercase mb-1 font-light;\r\n    color: #000;\r\n    font-size: 15px;\r\n  }\r\n\r\n  input {\r\n    @apply rounded-md border focus:outline-none w-full pl-11 pr-2 focus:placeholder-opacity-70;\r\n    height: 40px;\r\n    background-color: #ffffff;\r\n    border-color: #d9d9d9;\r\n    font-size: 17px;\r\n    color: #222;\r\n    &::placeholder {\r\n      color: #aaa;\r\n    }\r\n    &.custom {\r\n      @apply pl-4;\r\n      background-color: #f3f4f6 !important;\r\n      border-color: #f3f4f6 !important;\r\n      &.error {\r\n        border-color: #ef6a6a;\r\n      }\r\n    }\r\n    &.error {\r\n      border-color: #ef6a6a;\r\n    }\r\n    &::placeholder {\r\n      font-size: 15px;\r\n      color: #9b9dac;\r\n    }\r\n  }\r\n  .icon {\r\n    @apply absolute top-3 left-5;\r\n    color: #95989a;\r\n  }\r\n  .icon-2 {\r\n    @apply absolute right-5 top-3 cursor-pointer;\r\n    color: #95989a;\r\n  }\r\n}\r\n\r\n.link-auth-login {\r\n  color: #000000;\r\n  transition: all 0.2s ease;\r\n  &:hover {\r\n    color: #352d3b;\r\n  }\r\n}\r\n\r\n.link-auth-register {\r\n  background-color: #000000;\r\n  color: white;\r\n  border-radius: 4px;\r\n  width: 123px;\r\n  height: 40px;\r\n  display: flex;\r\n  transition: all 0.2s ease;\r\n  justify-content: center;\r\n  align-items: center;\r\n  &:hover {\r\n    background-color: #352d3b;\r\n  }\r\n}\r\n\r\n.submit-btn {\r\n  @apply rounded-md h-10 text-white flex justify-center items-center text-base w-full mt-16 mb-4;\r\n  background-color: #000000;\r\n  transition: all 0.2s ease;\r\n  &.no-top-margin {\r\n    margin-top: 0;\r\n  }\r\n  &:hover {\r\n    background-color: #352d3b;\r\n  }\r\n  &:disabled {\r\n    background-color: #d0d0d0;\r\n  }\r\n}\r\n\r\n.verification-code-styles {\r\n  @apply w-full;\r\n  --ReactInputVerificationCode-itemWidth: 60px;\r\n  --ReactInputVerificationCode-itemHeight: 50px;\r\n\r\n  .ReactInputVerificationCode__container {\r\n    @apply flex items-center gap-3 mt-7 mx-auto w-full justify-between;\r\n    max-width: 400px;\r\n  }\r\n\r\n  .ReactInputVerificationCode__item:focus {\r\n    outline: none;\r\n  }\r\n\r\n  .ReactInputVerificationCode__container div {\r\n    box-shadow: unset !important;\r\n  }\r\n\r\n  .ReactInputVerificationCode__item {\r\n    border-radius: 13px;\r\n    font-size: 16px !important;\r\n    border: 1px solid #d9d9d9;\r\n    background-color: #fff;\r\n    line-height: 50px !important;\r\n    color: #000;\r\n    &.is-active {\r\n      border: 1px solid #000000;\r\n    }\r\n  }\r\n\r\n  &.has-error {\r\n    .ReactInputVerificationCode__item {\r\n      border: 1px solid #ef6a6a;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.datetimepicker {\r\n  .MuiInputBase-root {\r\n    height: 40px;\r\n    background-color: #fff;\r\n    border-radius: 8px;\r\n    padding-right: 12px !important;\r\n    max-width: 180px;\r\n    &:hover {\r\n      border: none !important;\r\n    }\r\n    * {\r\n      color: #eaeaea;\r\n    }\r\n    input {\r\n      font-size: 13px;\r\n      padding-left: 5px !important;\r\n      color: #000!important;\r\n      &::placeholder {\r\n        opacity: 0 !important;\r\n      }\r\n      &:hover {\r\n        border: none !important;\r\n      }\r\n      &:focus {\r\n        &::placeholder {\r\n          opacity: 0;\r\n        }\r\n      }\r\n    }\r\n    .MuiSvgIcon-root {\r\n      fill: #000;\r\n      opacity: 0.38;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
